import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import Home from "../pages/Home";
import NotFound from "../pages/errors/NotFound";
import Projects from "../pages/Projects";

export default function RouteManager() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route exact path="/" element={<Home />} />
                    {["gallery", "projects", "g"].map((path, index) => <Route path={path} key={index} element={<Projects />} />)}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </div>
        </Router>
    );
};

